import { ReactiveVar } from '@apollo/client';
import { Organization } from '../../../generated/graphql';

export default function disposeLastAccessedOrganization(lastAccessedOrganizationVar: ReactiveVar<Organization | null>) {
  return () => {
    lastAccessedOrganizationVar(null);
    localStorage.removeItem('lastAccessedOrganization');
  };
}
